<form #form="ngForm" class="container-form with-nav-tabs" novalidate>
    <!--Options-->
    <div class="row container-form-options">
        <div class="col-12">
            <button type="button" class="btn btn-success mr-2" (click)="save()" id="btnSave">
                <i class="fas fa-check" aria-hidden="true"></i> Salvar
            </button>
              <button type="button" class="btn btn-light" (click)="cancel()">
                <i class="fas fa-undo" aria-hidden="true"></i> Cancelar
            </button>    
        </div>
    </div>

    <!--Content-->
    <div class="row container-form-content" *ngIf="entity">
        <div class="col-12 container-navs">
            <ul class="nav nav-tabs">
                <li class="nav-item">
                    <a class="nav-link active" data-target="#tabPrincipal" data-toggle="tab">Principal</a>
                </li>
                <li class="nav-item" *ngIf="entity.possuiSubRegioes">
                    <a class="nav-link" data-target="#tabSubRegioes" data-toggle="tab">Sub-regiões</a>
                </li>                                                              
            </ul>
            <div class="tab-content">
                <!-- Principal -->
                <div class="tab-pane active" id="tabPrincipal">
                    <div class="row">
                        <div class="form-group col-12 col-md-3">
                            <label for="codigo" class="col-form-label">Código</label>
                            <ng-template [ngIf]="entity.cadastroManual">
                                <input type="text" class="form-control" [(ngModel)]="entity.codigo"
                                    name="codigo" id="codigo" #codigo="ngModel" required="required">
                                <p class="form-text text-muted">Código da cidade no seu sistema ERP</p>
                                <sgt-form-control-error
                                    *ngIf="codigo.errors && codigo.errors.required && codigo.dirty"
                                    msgError="O código é obrigatório">
                                </sgt-form-control-error>                         
                            </ng-template>
                            <ng-template [ngIf]="!entity.cadastroManual">
                                <input type="text" class="form-control" [value]="entity.codigo" name="codigo" id="codigo"
                                    disabled="disabled" readonly="readonly">
                            </ng-template>                    
                        </div>
                        <div class="form-group col-12 col-md-3">
                            <label for="codigoIbge" class="col-form-label">Código IBGE</label>
                            <ng-template [ngIf]="entity.cadastroManual">
                                <input type="number" class="form-control" [(ngModel)]="entity.codigoIbge" 
                                    name="codigoIbge" id="codigoIbge" #codigoIbge="ngModel" required="required">
                                <p class="form-text text-muted">Código IBGE da cidade no seu sistema ERP</p>
                                <sgt-form-control-error
                                    *ngIf="codigoIbge.errors && codigoIbge.errors.required && codigoIbge.dirty"
                                    msgError="O código IBGE é obrigatório">
                                </sgt-form-control-error>                                      
                            </ng-template>
                            <ng-template [ngIf]="!entity.cadastroManual">
                                <input type="number" class="form-control" [value]="entity.codigoIbge" name="codigoIbge" id="codigoIbge"
                                    disabled="disabled" readonly="readonly">
                            </ng-template>                            
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-12">
                            <label for="nome" class="col-form-label">Nome</label>
                            <ng-template [ngIf]="entity.cadastroManual">
                                <input type="text" class="form-control" [(ngModel)]="entity.nome"
                                    name="nome" id="nome" #nome="ngModel" required="required" sgtUppercase>
                                <sgt-form-control-error
                                    *ngIf="nome.errors && nome.errors.required && nome.dirty"
                                    msgError="O nome é obrigatório">
                                </sgt-form-control-error>                                
                            </ng-template>
                            <ng-template [ngIf]="!entity.cadastroManual">
                                <input type="text" class="form-control" [value]="entity.nome" name="nome" id="nome"
                                    disabled="disabled" readonly="readonly">
                            </ng-template>                            
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-12">
                            <label for="estado" class="col-form-label">Estado</label>
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">
                                        {{entity.estado?.uf}}
                                    </span>
                                </div>
                                <ng-template [ngIf]="entity.cadastroManual">
                                    <select class="form-control"
                                        [ngModel]="entity.idEstado || ''" (ngModelChange)="onChangeEstado($event ? $event : null)"
                                        name="estado" id="estado" #estado="ngModel" required="required">
                                        <option value="">Selecione o estado...</option>
                                        <option *ngFor="let estado of estados" [ngValue]="estado.id">{{estado.nome}}</option>
                                    </select>
                                    <sgt-form-control-error
                                        *ngIf="estado.errors && estado.errors.required && estado.dirty"
                                        msgError="O estado é obrigatório">
                                    </sgt-form-control-error>                                         
                                </ng-template>
                                <ng-template [ngIf]="!entity.cadastroManual">
                                    <input type="text" class="form-control" [value]="entity.estado?.nome" name="estado" id="estado"
                                        disabled="disabled" readonly="readonly">
                                </ng-template>                                
                            </div>
                        </div>
                    </div>                    
                    <div class="row">
                        <div class="form-group col-12 col-md-3">
                            <label for="classificacao" class="col-form-label">Classificação</label>
                            <select class="form-control" name="classificacao" id="classificacao" 
                                [ngModel]="entity.classificacao || ''" (ngModelChange)="entity.classificacao = $event ? $event : null"
                                #classificacao="ngModel">
                                <option value="">Nenhuma classificação</option>
                                <option *ngFor="let classificacao of classificacoes" [ngValue]="classificacao.id">{{classificacao.nome}}</option>
                            </select>                                        
                        </div>                        
                    </div> 
                    <div class="row">
                        <div class="form-group col-12 checkbox">
                            <label>
                                <input type="checkbox" [(ngModel)]="entity.possuiSubRegioes" name="possuiSubRegioes" id="possuiSubRegioes"> Possui sub-regiões?
                            </label>                        
                        </div>                        
                    </div>
                </div>
                <!-- End Principal -->

                <!-- Sub-regiões -->
                <div class="tab-pane" id="tabSubRegioes" *ngIf="entity.possuiSubRegioes">
                    <sgt-cidade-sub-regiao
                        [entities]="entity.subRegioes">
                    </sgt-cidade-sub-regiao>
                </div>
                <!-- End  Sub-regiões -->
            </div>
        </div>
    </div>
</form>